import { useI18n } from '../i18n';
import CrystalShader from '../components/CrystalShader';
import Button from '../components/Button';

export default function Hero() {
  const { t } = useI18n();

  return (
    <section
      id="hero"
      className="relative flex min-h-screen items-center justify-center overflow-hidden pt-20"
    >
      <CrystalShader />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#FFFBEB]/60 via-transparent to-[#FFFBEB]" />
      <div className="relative z-10 mx-auto max-w-5xl px-6 text-center">
        <h1 className="font-['Russo_One'] text-5xl leading-tight font-normal uppercase text-[#0F172A] sm:text-6xl md:text-7xl lg:text-8xl">
          {t('hero.headline')}
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[#78350F] sm:text-xl md:text-2xl">
          {t('hero.subheadline')}
        </p>
        <div className="mt-10">
          <Button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            {t('hero.cta')}
          </Button>
        </div>
      </div>
    </section>
  );
}
